import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash'
import * as R from "ramda"
import { RotatingLines } from "react-loader-spinner";
import { useAppDispatch } from "../../hooks/hooks";
import { Swiper, SwiperSlide } from "swiper/react";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";
import ProgramCard from "./program-cards.component";
import { selectProgramsCreatedItem, selectProgramsListItems } from "../../redux/programs/selector";
import { programs } from "../../redux/programs/action";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { programSubscriptions } from "../../redux/program-subscriptions/action";
import Popup from "../../common/components/popup";
import AdvisorModal from "../membership/advisor-modal";
import TrainingModal from "./training-modal";

export default function Programs() {
  const dispatch = useAppDispatch();
  const listprograms = useSelector(selectProgramsCreatedItem)
  const statesItems = storePersist?.get("states")?.current?.items;
  const countriesItems = storePersist?.get("countries")?.current?.items;
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const programList = useSelector(selectProgramsListItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [selectTraining, setSelectTraining] = useState<any>({});
   const [showDetailsModal, setShowDetailsModal] = useState(false);



  const [selectedPrograms, setSelectedPrograms] = useState<any>({

  });
  const resetForm = () => {
    setSelectedPrograms({
      Login: {
        Phone: "",
        Email: ""
      },
      UserProfile: {
        FirstName: "",
        LastName: "",
        PersonTitle: ""
      },
      ONEUserInfo: {
        Biography: null,
        PhotoUrl: null,
        IsONEUserVerified: true,
        StartupName: "",
        YearsInOperation: "",
        IsTechFirstInnovation: true,
        StageOfTheStartup: "",
        Sector: "",
        WebsiteLink: "",
        utm_source: null,
        utm_medium: null,
        utm_campaign: null,
        utm_term: null,
        utm_content: null
      },
      Account: {
        IsPersonAccount: true,
        Name: "",
        TypeId: ""
      },
      PrimaryAddress: {
        address1: "",
        city: "",
        CountryId: "",
        StateProvinceId: "",
        ZipPostalCode: "",
      }
    });
  };



  useEffect(() => {
    if (listprograms?.isSuccess) {
      dispatch(programSubscriptions.resetAction({ actionType: 'create' }))
      dispatch(programSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-program-subscriptions`,
        entity: 'subscription',
        jsonData: {
          Records: [
            {

              "Email": selectedPrograms?.Login?.Email,
              "PhoneNumber": selectedPrograms?.Login?.Phone,
              "OwnerType": "oneprogram",
              "OwnerId": selectedPrograms?.OwnerId,
              "ONEProgramPolicyId": selectedPrograms?.ONEProgramPolicyId,
              "IsExistingUser": selectedPrograms?.IsExistingUser || false,

            }
          ]
        }

      }))
      resetForm();

      dispatch(programs.resetAction({ actionType: 'create' }))
    }
  }, [listprograms]);


  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const data = {
      "Login": {
        "Phone": selectedPrograms?.Login?.Phone,
        "Email": selectedPrograms?.Login?.Email,
      },

      "UserProfile": {
        "FirstName": selectedPrograms?.UserProfile?.FirstName,
        "LastName": "",
        "PersonTitle": ""
      },
      "ONEUserInfo": {
        "Biography": null,
        "PhotoUrl": null,
        "IsONEUserVerified": true,
        "StartupName": selectedPrograms?.ONEUserInfo?.StartupName,
        "YearsInOperation": "",
        "IsTechFirstInnovation": true,
        "StageOfTheStartup": selectedPrograms?.ONEUserInfo?.StageOfTheStartup,
        "Sector": selectedPrograms?.ONEUserInfo?.Sector,
        "WebsiteLink": selectedPrograms?.PrimaryAddress?.WebsiteLink,
        "utm_source": null,
        "utm_medium": null,
        "utm_campaign": null,
        "utm_term": null,
        "utm_content": null
      },

      "Account": {
        "IsPersonAccount": true,
        "Name": "ONE User 001",
        "TypeId": 440
      },

      "PrimaryAddress": {
        "address1": selectedPrograms?.PrimaryAddress?.address1,
        "address2": selectedPrograms?.PrimaryAddress?.address2,
        "city": selectedPrograms?.PrimaryAddress?.city,
        "CountryId": selectedPrograms?.PrimaryAddress?.CountryId,
        "StateProvinceId": selectedPrograms?.PrimaryAddress?.StateProvinceId,
        "ZipPostalCode": selectedPrograms?.PrimaryAddress?.ZipPostalCode,
      }




    }

    if (!selectedPrograms?.IsExistingUser) {

      await dispatch(programs.resetAction({ actionType: 'create' }))
      await dispatch(programs.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-users`,
        entity: 'register',
        jsonData: {
          records: [
            data
          ]
        }
      }))
      await resetForm();
    } else {
      dispatch(programSubscriptions.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/one-program-subscriptions`,
        entity: 'programs',
        jsonData: {
          Records: [
            {


              "Email": selectedPrograms?.Email,
              "PhoneNumber": selectedPrograms?.Phone,
              "OwnerType": "oneprogram",
              "OwnerId": selectedPrograms?.OwnerId,
              "ONEProgramPolicyId": selectedPrograms?.ONEProgramPolicyId,
              "IsExistingUser": selectedPrograms?.IsExistingUser || false,

            }
          ]
        }
      }))
      resetForm();
    }
  }



  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedPrograms({ ...selectedPrograms, [fields[0]]: value });
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedPrograms({ ...selectedPrograms, [field]: event })

  }




  const dummyData = [{
    id: 1,
    Name: "Programs Name 1"
  },
  {
    id: 2,
    Name: "Programs Name 2"
  }, {
    id: 3,
    Name: "Programs Name 3"
  }, {
    id: 4,
    Name: "Programs Name 4"
  }, {
    id: 5,
    Name: "Programs Name 5"
  }]

  const dataToRender = programList?.result?.items?.length > 0
    ? programList.result.items
    : dummyData;

  useEffect(() => {
    dispatch(programs.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/list`, entity: 'programs',
      jsonData:
      {
        "Context": {
          "Subscription": "ONE",
          "Domain": "ONE",
          "SubDomains": [],
          "Network": "Internal",
          "Application": "Management",
          "Channel": "Portal"
        },
        "Records": [
          {
            "Id": 0
          }
        ],
      }
    }))
  },
    [])



  const HomePageBannerData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ONE_DIGIIT_PROGRAM_MAIN_BANNER') : null;
  const banner: any = (HomePageBannerData && HomePageBannerData[0]?.src ? encodeURI(HomePageBannerData[0]?.src) : require('./../../assets/img/communities.jpg'))

  const workProcessData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_WORK_PROCESS') : null;

  const eMobilityHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY_HEADING') : null;

  const eMobilityData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_E_MOBILITY') : null;

  const serviceHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE_HEADING') : null;

  const serviceData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'LOGISTICS_QDP_HOME_MAIN_PAGE_SERVICE') : null;

  const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

  // const banner = require('../../assets/img/programs.jpg')

  let oneprogram = _.find(programList?.result?.items, ['Id', Number(selectedPrograms.ONEProgramPolicyId)]);



 const handlePrograms = (membership: any) => {
        setSelectTraining(membership);
        setShowDetailsModal(true);
    };

    const closeModal = () => {
        setShowDetailsModal(false);
        setSelectTraining({});
    };

    const NewItemPopup = () => (
        <Popup onClose={closeModal}>
            <TrainingModal Close={closeModal}  />
        </Popup>
    );

  return (
    <>
 {showDetailsModal && <NewItemPopup />}
      <div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}>
        <div className="flex justify-around items-center p-1 w-full h-[650px] px-10">
          {/* Left side text section */}
          <div className="flex p-2 flex-col justify-between items-center w-[800px]">
            {/* <p className="text-4xl font-normal text-white text-center">{CargoPageBannerData[0]?.title}</p>
                            <p className="text-xl pt-20 text-white text-center">{CargoPageBannerData[0]?.subTitle}</p> */}
            <p className="text-4xl font-normal text-white text-center"></p>
            <p className="text-xl pt-20 text-white text-center"></p>
          </div>

          {/* Right side form section */}
						<div className="w-1/3 flex justify-center items-start  mt-20 rounded-2xl bg-white">
            <div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
              <div className="text-2xl text-primary font-bold py-5">Training Registration Form</div>
              <div className=" w-full px-3 font-bold space-y-2">

                <div className=" w-full px-3 font-bold space-y-2">
                  <div className=" w-full pt-2">
                    <div className="font-normal ">
                      <input
                        type="checkbox"
                        name="IsExistingUser"
                        checked={selectedPrograms?.IsExistingUser || false}
                        onChange={(event) => {
                          handleChange(event.target.checked, 'IsExistingUser');
                        }}
                        className="mr-2 w-4 h-4"
                      />
                      <label htmlFor="IsExistingUser" className="text-base">
                        Are you already registered?
                      </label>
                    </div>
                  </div>
                </div>
                {!selectedPrograms?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full pt-2">
                      <div className="font-normal ">
                        <input
                          required
                          type="text"
                          name={"FirstName"}
                          placeholder="Name"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base`}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'UserProfile.FirstName',
                              selectedPrograms?.UserProfile
                            );

                          }}
                          value={selectedPrograms?.UserProfile?.FirstName} />
                      </div>
                    </div>
                  </div>
                )}
                {selectedPrograms?.IsExistingUser && (
                  <div className="flex flex-col space-y-2">

                    {/* Instructional label - show only if both fields are empty */}
                    {!selectedPrograms?.Email && !selectedPrograms?.Phone && (
                      <label className="text-sm text-gray-700 font-medium mb-2">
                        Please enter <span className="text-blue-600 font-semibold">either your Email or Phone Number</span>
                      </label>
                    )}

                    <div className="flex flex-row space-x-2">

                      {/* Email Input */}
                      {!selectedPrograms?.Phone && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Email</label>
                            <input
                              required
                              type="email"
                              name="Email"
                              placeholder="Email"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value, 'Email');
                              }}
                              value={selectedPrograms?.Email}
                            />
                          </div>
                        </div>
                      )}

                      {/* Phone Input */}
                      {!selectedPrograms?.Email && (
                        <div className="w-full">
                          <div className="border-0 font-normal">
                            <label className="text-xs text-gray-600 pl-1">Phone Number</label>
                            <input
                              required
                              maxLength={10}
                              type="text"
                              name="Phone"
                              placeholder="Phone Number"
                              pattern="\d{10}"
                              className="w-full py-3 px-3 border-b-2 border-black text-base"
                              onChange={(event) => {
                                handleChange(event.target.value.replace(/\D/g, ''), 'Phone');
                              }}
                              value={selectedPrograms?.Phone}
                            />
                            {selectedPrograms?.Phone?.length > 0 &&
                              selectedPrograms?.Phone?.length < 10 && (
                                <span className="text-red-600 text-xs">
                                  Please enter a valid number.
                                </span>
                              )}
                          </div>
                        </div>
                      )}

                    </div>
                  </div>
                )}



                {!selectedPrograms?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="email"
                          name={"Email"}
                          placeholder="Email"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'Login.Email',
                              selectedPrograms?.Login
                            );
                          }}
                          value={selectedPrograms?.Login?.Email} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          maxLength={10}
                          type="text"
                          name={"Phone"}
                          placeholder="Phone Number"
                          pattern="\d{10}"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value.replace(/\D/g, ''),
                              'Login.Phone',
                              selectedPrograms?.Login
                            );
                          }}
                          value={selectedPrograms?.Login?.Phone} />
                        {selectedPrograms?.Phone && selectedPrograms?.Phone?.length < 10 && (
                          <span className="text-red-600 text-xs">
                            Please enter a valid number.
                          </span>
                        )}
                      </div>

                    </div>

                  </div>
                )}
                {!selectedPrograms?.IsExistingUser && (
                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address1"}
                          placeholder="Building"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address1',
                              selectedPrograms?.PrimaryAddress
                            );
                          }}
                          value={selectedPrograms?.PrimaryAddress?.address1} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"address2"}
                          placeholder="Locality"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.address2',
                              selectedPrograms?.PrimaryAddress
                            );
                          }}
                          value={selectedPrograms?.PrimaryAddress?.address2} />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedPrograms?.IsExistingUser && (

                  <div className="flex flex-row space-x-2 ">
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"city"}
                          placeholder="City"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.city',
                              selectedPrograms?.PrimaryAddress
                            );
                          }}
                          value={selectedPrograms?.PrimaryAddress?.city} />
                      </div>
                    </div>
                    <div className=" w-full">

                      <div className="border-0 font-normal">
                        <input
                          required
                          type="text"
                          name={"ZipPostalCode"}
                          placeholder="Pincode"
                          className={`w-full py-3 px-3 border-b-2 border-black text-base `}
                          onChange={(event) => {
                            handleInnerFormChange(
                              event.target.value,
                              'PrimaryAddress.ZipPostalCode',
                              selectedPrograms?.PrimaryAddress
                            );
                          }}
                          value={selectedPrograms?.PrimaryAddress?.ZipPostalCode} />
                      </div>
                    </div>

                  </div>
                )}
                {!selectedPrograms?.IsExistingUser && (
                  <div className="flex flex-row space-x-2">

                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="country"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.CountryId',
                            selectedPrograms?.PrimaryAddress
                          )}
                          value={selectedPrograms?.PrimaryAddress?.CountryId || ''}
                        >
                          <option value="" disabled hidden>Select Country</option>

                          {countriesItems.map((country: any) => (
                            <option key={country.Id} value={country.Id}>{country.Name}</option>
                          ))}

                        </select>
                      </div>
                    </div>


                    <div className="w-full">
                      <div className="border-0 font-normal">
                        <select
                          required
                          name="StateProvinceId"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleInnerFormChange(event.target.value, 'PrimaryAddress.StateProvinceId',
                            selectedPrograms?.PrimaryAddress
                          )}
                          value={selectedPrograms?.PrimaryAddress?.StateProvinceId || ''}
                        >
                          <option value="" disabled hidden>Select State</option>
                          {statesItems?.length > 0 ? (
                            statesItems.map((state, index) => (
                              <option key={index} value={state.Id}>
                                {state.Name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>No states available</option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div>
                )}


                <div className="flex flex-row space-x-2">
                  <div className="w-full pt-2">
                    <div className="font-normal">
                      <select
                        required
                        name="program"
                        className="w-full py-3 px-3 border-b-2 border-black text-base"
                        onChange={(event) => handleChange(event.target.value, 'ONEProgramPolicyId')}
                        value={selectedPrograms?.ONEProgramPolicyId || ''}
                      >
                        <option value="" disabled hidden>
                          Select a Program Policy
                        </option>
                        {programList?.result?.items?.length > 0 ? (
                          programList.result.items.map((program, index) => (
                            <option key={index} value={program.Id}>
                              {program.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No Programs Policy available now
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>


                {selectedPrograms?.ONEProgramPolicyId ?
                  <div className="flex flex-row space-x-2">
                    <div className="w-full pt-2">
                      <div className="font-normal">
                        <select
                          required
                          name="program"
                          className="w-full py-3 px-3 border-b-2 border-black text-base"
                          onChange={(event) => handleChange(event.target.value, 'OwnerId')}
                          value={selectedPrograms?.OwnerId || ''}
                        >
                          <option value="" disabled hidden>
                            Select a Program
                          </option>
                          {Array.isArray(oneprogram?.ONEPrograms) && oneprogram.ONEPrograms.length > 0 ? (
                            oneprogram.ONEPrograms.map((program) => (
                              <option key={program.EntityInfo.Id} value={program.EntityInfo.Id}>
                                {program.EntityInfo.Name}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No Programs available now
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  </div> : null
                }
              </div>
              {/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

								<div className={`${isButtonLoading ? 'bg-primary/70' : 'bg-primary'} px-5 flex w-full flex-row items-center justify-center mt-5 mb-10 rounded-lg`}>
                <div

                  onClick={handleSubmit}
                  className=" flex-row flex items-center justify-center text-light text-base my-3 font-bold cursor-pointer"
                >
                  Subscribe
                  <div className={`pl-2 ${isButtonLoading ? 'visible' : 'invisible'}`}>
                    <RotatingLines
                      visible={true}
                      width={'20'}
                      strokeColor="#fff"
                      strokeWidth="6"
                      animationDuration="0.75"
                      ariaLabel="rotating-lines-loading"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div className="flex w-full py-10">
        <div className="swiper p-4 w-full" id="slider5">
          <div className="swiper-wrapper w-full">
            <Swiper
              navigation={{
                nextEl: '.swiper-button-next-ex5',
                prevEl: '.swiper-button-prev-ex5',
              }}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                1536: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1280: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                320: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
              }}
            >
              {dataToRender.map((item: any, i: any) => {

                return (
                  <SwiperSlide key={i}>
                    <ProgramCard
                      programDetails={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </div>

        <div className="relative bg-gradient-to-r from-[#fff4f0] via-[#fff9f7] to-[#fff4f0] py-20 px-6 mt-20 rounded-3xl shadow-lg">
  <h2 className="text-4xl font-extrabold text-center mb-6 flex justify-center items-center gap-3 text-gray-900">
    <span className="animate-pulse">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="34"
        height="34"
        className="text-yellow-500"
        fill="none"
      >
        <path
          d="M3 12C7.5 12 12 7.5 12 3C12 7.5 16.5 12 21 12C16.5 12 12 16.5 12 21C12 16.5 7.5 12 3 12Z"
          stroke="#f5ae3b"
          strokeWidth="1.8"
          strokeLinejoin="round"
        ></path>
        <path
          d="M2 19.5C2.83333 19.5 4.5 17.8333 4.5 17C4.5 17.8333 6.16667 19.5 7 19.5C6.16667 19.5 4.5 21.1667 4.5 22C4.5 21.1667 2.83333 19.5 2 19.5Z"
          stroke="#f5ae3b"
          strokeWidth="1.8"
          strokeLinejoin="round"
        ></path>
        <path
          d="M16 5C17 5 19 3 19 2C19 3 21 5 22 5C21 5 19 7 19 8C19 7 17 5 16 5Z"
          stroke="#f5ae3b"
          strokeWidth="1.8"
          strokeLinejoin="round"
        ></path>
      </svg>
    </span>
    Ready to Begin Your Training Journey?
  </h2>

  <p className="text-center text-gray-600 max-w-2xl mx-auto mb-10 text-lg leading-relaxed">
    Empower yourself with <span className="font-semibold text-gray-900">hands-on training</span> 
    designed to build real-world skills. Our programs combine 
    <span className="text-yellow-600 font-medium"> expert guidance</span>, 
    practical learning, and the latest tools to help you 
    <span className="text-yellow-600 font-medium"> stay ahead in the digital era</span>.
  </p>

  <div className="flex justify-center gap-6">
    <button     onClick={handlePrograms} className="border border-gray-700 text-gray-800 px-8 py-3 rounded-2xl hover:bg-gray-100 hover:scale-105 transform transition-all duration-300 font-medium">
       Record Your Training Interest
    </button>
  </div>
</div>

    </>



  );
}